import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';
import buildTableFilterQueryOpts from '@/shared/tablefilter/filters';

import { ILicenseData } from '@/shared/model/license-data.model';

const baseApiUrl = 'api/license-data';

export default class LicenseDataService {
  public find(id: number): Promise<ILicenseData> {
    return new Promise<ILicenseData>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      // pagination and sorting
      let queryParameter = buildPaginationQueryOpts(paginationQuery);
      if (queryParameter.length > 0) {
        queryParameter += '&';
      }
      // filtering
      queryParameter += buildTableFilterQueryOpts(paginationQuery);

      axios
        .get(baseApiUrl + `?${queryParameter}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: ILicenseData): Promise<ILicenseData> {
    return new Promise<ILicenseData>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: ILicenseData): Promise<ILicenseData> {
    return new Promise<ILicenseData>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdate(entity: ILicenseData): Promise<ILicenseData> {
    return new Promise<ILicenseData>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public generate(entity: ILicenseData): Promise<ILicenseData> {
    return new Promise<ILicenseData>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/generate/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
